export default __webpack_public_path__ + "static/simple-scatter-10f18b89b3576d78b29ca0bc7aaa8e00.png";